import queryString from "query-string";

import { BILLING_SETTINGS } from "constants/actionTypes";

import { serializeBillingSettings } from "lib/serializers/billingSettings";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { URLCreatorProps } from "./types";

function urlCreator(props: URLCreatorProps = {}): string {
  const { action, changesSince, id } = props;
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/billing-settings/", id, action),
    query: {
      changesSince,
    },
  });
}

export const BillingSettingsAction = offlineActionCreator(
  BILLING_SETTINGS,
  serializeBillingSettings,
  urlCreator,
  false,
);
